import Cookies from 'js-cookie';

let accessid = ''
let accesskey = ''
let host = ''
let policyBase64 = ''
let signature = ''
let callbackbody = ''
let filename = ''
let key = ''
let expire = 0
let g_object_name = ''
let g_object_name_type = ''
let timestamp = ''
let dataD = {}
let now = timestamp = Date.parse(new Date()) / 1000;

export const send_request = () => {
  var xmlhttp = null;
  if (window.XMLHttpRequest) {
    xmlhttp = new XMLHttpRequest();
  }
  else if (window.ActiveXObject) {
    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
  }

  if (xmlhttp != null) {
    let serverUrl = process.env.HOST + '/oss/get_policy'
    let cid = Cookies.get('cid')
    let uid = Cookies.get('uid')
    let token = Cookies.get('token')
    xmlhttp.open("GET", serverUrl, false)
    xmlhttp.setRequestHeader('cid', cid)
    xmlhttp.setRequestHeader('uid', uid)
    xmlhttp.setRequestHeader('token', token)
    xmlhttp.send(null);
    return xmlhttp.responseText
  }
  else {
    alert("Your browser does not support XMLHTTP.");
  }
}

const get_signature = () => {
  //可以判断当前expire是否超过了当前时间,如果超过了当前时间,就重新取一下.3s 做为缓冲
  let now = timestamp = Date.parse(new Date()) / 1000;
    let body = send_request()
    var obj = eval("(" + body + ")");
    host = obj.data['host']
    var obj = eval("(" + body + ")");
    policyBase64 = obj.data['policy']
    accessid = obj.data['accessid']
    signature = obj.data['signature']
    key = obj.data['dir']
    return true;
  // return false;
};

const random_string = (len) => {
  len = len || 32;
  var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  var maxPos = chars.length;
  var pwd = '';
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

const get_suffix = (filename) => {
  let pos = filename.lastIndexOf('.')
  let suffix = ''
  if (pos != -1) {
    suffix = filename.substring(pos)
  }
  return suffix;
}

export const check_object_radio = () => {
  g_object_name_type = 'random_name';
}

const calculate_object_name = (filename) => {
  if (g_object_name_type == 'local_name') {
    g_object_name += "${filename}"
  }
  else if (g_object_name_type == 'random_name') {
    let suffix = get_suffix(filename)
    g_object_name = key + random_string(10) + suffix
  }
  return ''
}

export const get_uploaded_object_name = (filename) => {
  if (g_object_name_type == 'local_name') {
    let tmp_name = g_object_name
    tmp_name = tmp_name.replace("${filename}", filename);
    return tmp_name
  }
  else if (g_object_name_type == 'random_name') {
    return g_object_name
  }
}

export const set_upload_param = (up, filename, ret) => {
  if (ret == false) {
    ret = get_signature()
  }
  if (filename != '') {
    let suffix = get_suffix(filename)
    calculate_object_name(filename)
  }

  let new_multipart_params = {
    'key': g_object_name,
    'policy': policyBase64,
    'OSSAccessKeyId': accessid,
    'success_action_status': '200', //让服务端返回200,不然，默认会返回204
    'callback': callbackbody,
    'signature': signature,
  };

  up.setOption({
    'url': host,
    'multipart_params': new_multipart_params
  });
  up.start();
}

export default {
  set_upload_param,
  check_object_radio,
  get_uploaded_object_name,
  send_request
};





// WEBPACK FOOTER //
// ./src/common/libs/vue-upload/base.js